import { isNumberFormat } from "widgets/utils";

export function formatRegion(contig: string, start: number, stop: number) {
  if (!isNumberFormat(start) || !isNumberFormat(stop) || contig == null || start == null || stop == null) {
    return null;
  }

  return `${contig.length > 0 ? `${contig}: ` : ""}${start.toLocaleString("en-US")} - ${stop.toLocaleString("en-US")}`;
}
